exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.crud-list th.sortable {\n  cursor: pointer; }\n\n@media (max-width: 500px) {\n  table.crud-list {\n    max-width: auto !important;\n    display: block !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/crud-list/crud-list.component.scss
// module id = ../../../../../src/app/shared/modules/crud/crud-list/crud-list.component.scss
// module chunks = main